import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=1e75285c&scoped=true"
import script from "./UserProfileEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfileEdit.vue?vue&type=style&index=0&id=1e75285c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e75285c",
  null
  
)

export default component.exports